export const NO_EMAIL = 'Required';
export const INVALID_EMAIL = 'A valid email is required';
export const INVALID_PASSWORD = 'Password does not meet requirements';
